import { createTheme, ThemeProvider, responsiveFontSizes } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { getApp, initializeApp } from "firebase/app";
/* import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check"; */
import { connectFirestoreEmulator, doc, getDoc, getFirestore } from "firebase/firestore";
import { getAuth, onAuthStateChanged, connectAuthEmulator } from "firebase/auth";
import TopBar from './components/nav/TopBar';
import React from 'react';
import { Box } from '@mui/material';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import Footer from './components/nav/Footer';
import MetaValues from './components/MetaValues';

/* const app =  */initializeApp({
  apiKey: "AIzaSyCNu9nrOHwLDPtRdlb0LOoORqJmU7KrK0Y",
  authDomain: "rentmanager-d5294.firebaseapp.com",
  projectId: "rentmanager-d5294",
  storageBucket: "rentmanager-d5294.appspot.com",
  messagingSenderId: "596983987464",
  appId: "1:596983987464:web:b88a7bdba0cd1ad55380bd"
});

/* if (import.meta.env.PROD) {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider("6LclWhwgAAAAAHFEMM_SfTFeuDvQ8Bo3hRW-FUMl"),
    isTokenAutoRefreshEnabled: true
  });
} */

const auth = getAuth();
const db = getFirestore();
const functions = getFunctions(getApp(), "europe-west3");

// eslint-disable-next-line no-constant-condition
if (import.meta.env.DEV && false) {
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: false });
  connectFunctionsEmulator(functions, "localhost", 5001);
}

let theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#386838',
    },
    secondary: {
      main: '#ffffff',
    },
    background: {
      default: '#386838',
      paper: '#294629',
    },
    text: {
      primary: '#ffffff',
    }
  },
  typography: {
    fontFamily: 'Montserrat Variable',
    h1: {
      fontWeight: 700,
      fontSize: "4rem"
    },
    h2: {
      fontWeight: 600,
      fontSize: "3rem"
    },
    h3: {
      fontWeight: 550,
      fontSize: "2rem"
    },
    h6: {
      fontWeight: 600,
      fontSize: "1.2rem"
    },
    subtitle1: {
      fontWeight: 400,
      fontSize: "1.24rem",
      lineHeight: 1.3,
      letterSpacing: "0em"
    }
  },
  components: {
    MuiLink: {
      defaultProps: {
        color: "#ffffff",
      }
    }
  }
})

theme = createTheme(theme, {
  palette: {
    paper: theme.palette.augmentColor({
      color: {
        main: "#294629",
      },
      name: "paper"
    })
  }
})
theme = keepGridAlignedMaxFontSizes(responsiveFontSizes(theme));

// MUI 9 stopped grid-aligning the font size at the largest responsive breakpoint
// (mui/material-ui#40255), which changes heading sizes on desktop. Restore the
// MUI <= 7 values so the site keeps its original look.
function keepGridAlignedMaxFontSizes(theme) {
  const { typography, breakpoints } = theme;
  const lastBreakpoint = breakpoints.values.lg;
  const mediaQuery = `@media (min-width:${lastBreakpoint}px)`;
  const variants = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'];
  variants.forEach(variant => {
    const style = typography[variant];
    if (!style?.[mediaQuery] || typeof style.lineHeight !== "number") {
      return;
    }
    const minFontSize = parseFloat(style.fontSize);
    const maxFontSize = parseFloat(style[mediaQuery].fontSize);
    const grid = 4 / (style.lineHeight * typography.htmlFontSize);
    const size = minFontSize + ((maxFontSize - minFontSize) / lastBreakpoint) * lastBreakpoint;
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    const aligned = size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
    style[mediaQuery] = { ...style[mediaQuery], fontSize: `${Math.round(aligned * 10000) / 10000}rem` };
  });
  return theme;
}

function App() {
  const [loggedIn, setLoggedIn] = React.useState(false);
  const [isAdmin, setIsAdmin] = React.useState(-1);
  const pageTitle = "SL Homes";

  React.useEffect(() => {
    return onAuthStateChanged(auth, user => {
      const realUserLoggedIn = (user && !user.isAnonymous) ? true : false;
      setLoggedIn(realUserLoggedIn);

      if (realUserLoggedIn) {
        getDoc(doc(db, "users", user.uid)).then(snap => {
          if (snap.data().role !== undefined && snap.data().role === "admin") {
            setIsAdmin(1);
          } else {
            setIsAdmin(0);
          }
        })
      } else {
        setIsAdmin(0);
      }
    })
  }, []);


  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh", maxWidth: "100vw" }}>
        <MetaValues title="Stellplätze in Welzow" />
        <TopBar pageTitle={pageTitle} isAdmin={isAdmin} />
        <main style={{ display: "flex", flexDirection: "column", flexGrow: 1, marginTop: 60 }}>
          <Outlet context={[isAdmin]} />
        </main>
        <Footer loggedIn={loggedIn} />
      </Box>
    </ThemeProvider>
  );
}


export default App;
